import { type FC, type Dispatch, type SetStateAction } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PayByStripe from '../Payment/PayByStripe';
import { type PaymentIntent } from '@/api/registration/payment';

interface StripePaymentProps {
  isValid: boolean
  setErrors: Dispatch<SetStateAction<string[]>>
  options: PaymentIntent
}

const StripePayment: FC<StripePaymentProps> = ({ isValid, setErrors, options }) => {
  const stripePromise = loadStripe(options.publishableKey);

  return (
    <Elements stripe={stripePromise} options={{ clientSecret: options.clientSecret }}>
      <PayByStripe
        isValid={isValid}
        setErrors={setErrors}
        options={options}
      />
    </Elements>
  );
};

export default StripePayment;
